import { AttachedTrait } from '../attachedtrait/AttachedTrait';
import { actorFilterRegistry, aspectFilterRegistry } from '../../../registry/Registry';
import { mergeIntoAspectsTemplate } from './AttachedActionTrait';
export class AttachedExportTrait extends AttachedTrait {
    get actorFilterRegs() {
        return this.trait.value.actorFilterKeys
            .map(actorFilterKey => actorFilterRegistry.registry_object[actorFilterKey])
            .filter(r => !!r);
    }
    get aspectFilterRegs() {
        return this.trait.value.aspectFilterKeys
            .map(aspectFilterKey => aspectFilterRegistry.registry_object[aspectFilterKey])
            .filter(r => !!r);
    }
    get actorAndAspectFilterTemplates() {
        return [...this.actorFilterRegs, ...this.aspectFilterRegs].map(r => r.params).filter(t => !!t);
    }
    get aspectsTemplate() {
        const aspectsTemplate = super.aspectsTemplate;
        this.actorAndAspectFilterTemplates.forEach(t => mergeIntoAspectsTemplate(t, aspectsTemplate));
        return aspectsTemplate;
    }
}
